import { sd_modal } from "../sd_modal/sd_modal";

const POPUP_STORAGE_KEY = 'popupKey_date';

function markPopupAsShown() {
  localStorage.setItem(POPUP_STORAGE_KEY, new Date().toDateString());
}

function isDismissInteraction(popupEl: HTMLElement, target: HTMLElement) {
  if (target.closest('.sd-modal__close')) return true;
  if (target.closest('.sd-popup-card__button a')) return true;

  // click en el overlay (solo si el overlay cierra la modal)
  return target === popupEl && popupEl.dataset.overlayClickable !== 'false';
}

function sd_popup() {

  // funcionalidades del modal (siempre: habilita clicks del side-icon en mobile)
  sd_modal();

  const popupEl = document.querySelector<HTMLElement>('#popup_modal');
  if( !popupEl ) return;

  // en mobile no se abre automáticamente: el usuario lo lanza via side-icon
  // el localStorage no se escribe en mobile para no bloquear visitas manuales
  const isMobile = window.matchMedia('(max-width: 767px)').matches;
  if( isMobile ) return;

  // -- a partir de aquí solo desktop --

  // comprobar si ya se ha mostrado el popup hoy
  if( localStorage.getItem(POPUP_STORAGE_KEY) === new Date().toDateString() ) return;

  // se marca como visto solo cuando el usuario interactúa con él, para que
  // las recargas de página (p. ej. al aceptar el banner de cookies) no lo consuman
  popupEl.addEventListener('click', (e) => {
    if( isDismissInteraction(popupEl, e.target as HTMLElement) ) {
      markPopupAsShown();
    }
  });

  popupEl.classList.add('sd-modal--open');
}

export {
  sd_popup
}
